<div class="ceils-content-wrapper d-flex flex-column">
  <ng-container *ngIf="top; else elseBlock">
    <ng-container *ngIf="top.people.slice(0, 5); let people">
      <ng-container *ngIf="people.length">
        <div
          class="ceils-content-header d-flex align-items-md-center justify-content-md-between flex-column flex-md-row"
        >
          <div class="d-flex ceils-content-header-title align-items-center">
            <div class="title"> People </div>
          </div>
        </div>

        <section
          class="d-flex flex-wrap flex-column flex-column flex-md-row ceils-content-section profile-ceils margin-t-1"
        >
          <app-profile-badge
            [profile]="profile"
            (connect)="onProfileConnect($event)"
            (disconnect)="onProfileDisconnect($event)"
            *ngFor="let profile of people"
          ></app-profile-badge>
        </section>

        <button class="search-see-more-btn btn" (click)="onSeeMore('people'); false">See more</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="top.organizations.slice(0, 5); let organizations">
      <ng-container *ngIf="organizations.length">
        <div
          class="ceils-content-header d-flex align-items-md-center justify-content-md-between flex-column flex-md-row"
        >
          <div class="d-flex ceils-content-header-title align-items-center">
            <div class="title"> Organizations </div>
          </div>
        </div>

        <section
          class="d-flex flex-wrap flex-column flex-column flex-md-row ceils-content-section profile-ceils margin-t-1"
        >
          <app-organization-badge
            [organization]="organization"
            (follow)="onOrganizationFollow($event)"
            (unfollow)="onOrganizationUnfollow($event)"
            *ngFor="let organization of organizations"
          >
          </app-organization-badge>
        </section>

        <button class="search-see-more-btn btn" (click)="onSeeMore('organizations'); false">See more</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="top.discussions.slice(0, 4); let discussions">
      <ng-container *ngIf="discussions.length">
        <div
          class="ceils-content-header d-flex align-items-md-center justify-content-md-between flex-column flex-md-row"
        >
          <div class="d-flex ceils-content-header-title align-items-center">
            <div class="title"> Discussions </div>
          </div>
        </div>

        <section
          class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section margin-t-1"
        >
          <app-discussion-badge [discussion]="discussion" *ngFor="let discussion of discussions">
          </app-discussion-badge>
        </section>

        <button class="search-see-more-btn btn" (click)="onSeeMore('discussions'); false">See more</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="top.groups.slice(0, 4); let groups">
      <ng-container *ngIf="groups.length">
        <div
          class="ceils-content-header d-flex align-items-md-center justify-content-md-between flex-column flex-md-row"
        >
          <div class="d-flex ceils-content-header-title align-items-center">
            <div class="title"> Groups </div>
          </div>
        </div>

        <section
          class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section margin-t-1"
        >
          <app-group-badge [group]="group" *ngFor="let group of groups"></app-group-badge>
        </section>

        <button class="search-see-more-btn btn" (click)="onSeeMore('groups'); false">See more</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="top.clubs.slice(0, 4); let clubs">
      <ng-container *ngIf="clubs.length">
        <div
          class="ceils-content-header d-flex align-items-md-center justify-content-md-between flex-column flex-md-row"
        >
          <div class="d-flex ceils-content-header-title align-items-center">
            <div class="title"> Clubs </div>
          </div>
        </div>

        <section
          class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section margin-t-1"
        >
          <!--            <app-group-badge [group]="group" *ngFor="let group of clubs"></app-group-badge>-->
          <app-business-club-item
            class="ceil-article-item business-block-item"
            [club]="group"
            *ngFor="let group of clubs"
          >
          </app-business-club-item>
        </section>

        <button class="search-see-more-btn btn" (click)="onSeeMore('clubs'); false">See more</button>
      </ng-container>
    </ng-container>

    <!-- <div
            class="ceils-content-header d-flex  align-items-md-center justify-content-md-between flex-column flex-md-row">
            <div class="d-flex ceils-content-header-title align-items-center">
                <div class="title">
                    Events
                </div>
            </div>
        </div>

        <section
            class="d-flex flex-wrap flex-column flex-md-row justify-content-md-between ceils-content-section margin-t-1">
            <app-event-badge [event]="event" *ngFor="let event of top.events.slice(0, 4)"></app-event-badge>
        </section>

        <button class="search-see-more-btn btn" (click)="onSeeMore('events'); false">See more</button> -->
  </ng-container>
  <ng-template #elseBlock>
    <app-loader-2></app-loader-2>
  </ng-template>
</div>
